"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBackgroundImage = exports.DEFAULT_BACKGROUND_IMAGE_PATTERN_REPEAT = exports.DEFAULT_BACKGROUND_IMAGE_REPEAT = exports.DEFAULT_BACKGROUND_SIZE = void 0;
var tslib_1 = require("tslib");
var postcss = tslib_1.__importStar(require("postcss"));
var stylable_shorthands_1 = require("../../../stylable-shorthands");
var stylable_site_vars_1 = require("../../../stylable-site-vars");
exports.DEFAULT_BACKGROUND_SIZE = 'cover';
exports.DEFAULT_BACKGROUND_IMAGE_REPEAT = 'no-repeat';
exports.DEFAULT_BACKGROUND_IMAGE_PATTERN_REPEAT = 'repeat';
function parseBackgroundImage(imageLayer, evalDeclarationValue) {
    if (evalDeclarationValue === void 0) { evalDeclarationValue = stylable_site_vars_1.DEFAULT_EVAL_DECLARATION_VALUE; }
    if (imageLayer === undefined) {
        return {};
    }
    var shorthand = new stylable_shorthands_1.StylableShorthands(evalDeclarationValue);
    var expandedWithoutDefaults = shorthand.expandDeclaration(postcss.decl({ prop: 'background', value: imageLayer }), {}, false);
    var expandedWithDefaults = shorthand.expandDeclaration(postcss.decl({ prop: 'background', value: imageLayer }));
    if (!expandedWithoutDefaults['background-position']) {
        expandedWithDefaults['background-position'] = '50% 50%';
    }
    if (!expandedWithoutDefaults['background-repeat']) {
        expandedWithDefaults['background-repeat'] = exports.DEFAULT_BACKGROUND_IMAGE_PATTERN_REPEAT;
    }
    return expandedWithDefaults;
}
exports.parseBackgroundImage = parseBackgroundImage;
//# sourceMappingURL=background-utils.js.map